// @flow

import * as React from 'react'

let mountNum = 0

export default function (width?: number) {
  return function (InnerComp: React.ComponentType<*>) {
    class FixedContent extends React.Component<*, *> {
      setFontSize () {
        var designedWidth = 750
        // $FlowFixMe
        let actualWidth = width || Math.min(450, document.body.clientWidth)
        // $FlowFixMe
        document.documentElement.style.fontSize =
          actualWidth * 100 / designedWidth + 'px'
      }

      componentWillMount () {
        this.setFontSize()
      }

      componentDidMount () {
        if (mountNum > 0) {
          console.error(
            'FixedContent is designed to be mounted only once.',
            'mountNum:' + mountNum
          )
        }
        mountNum++
        if (width == null) {
          window.addEventListener('resize', this.setFontSize)
        }
      }

      componentWillUnmount () {
        mountNum--
        window.removeEventListener('resize', this.setFontSize)
      }

      render () {
        return <InnerComp {...this.props} />
      }
    }
    return FixedContent
  }
}



// WEBPACK FOOTER //
// ./src/frame/hoc/fixedContent.js